import Vue from "vue";
import {Area} from "../enums/area";

export default Vue.extend({
  computed: {
    isPreview(): boolean {
      return this.$router.currentRoute.name === Area.listViewPreview ||
        this.$router.currentRoute.name === Area.detailViewPreview;
    },
  },
});